import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CellType } from '../../../../../enums/cellType';
import { fetchGetAuth, isCharedi } from '../../../../../utils/utils';
import { useParams } from 'react-router';
import ChangeClass from './selectClasses';
import ScoreboardTable from '../../ScoreboardTable/ScoreboardTable';
import classes from './StudentsTab.module.css';

const TAB_CONFIG = {
  boardName: 'students',
  tabType: 'student',
  columns: [
    { key: 'rank', type: CellType.RANK, text: 'rank', cssClass: classes.col_rank },
    { key: 'name', type: CellType.TEXT_STUDENT_NAME, text: 'student', cssClass: classes.col_textStudentName },
    { key: 'characterRank', type: CellType.TEXT_MONSTER, text: 'monster', cssClass: classes.col_textMonster },
    { key: 'challenges', type: CellType.PROGRESS, text: 'solvedStages', cssClass: classes.col_progress },
    { key: 'score', type: CellType.STARS, text: 'stars', cssClass: classes.col_stars },
  ],
  studentsEndpoint: 'Scoreboard/class/students',
  currentIdKey: 'student',
  titleKey: 'studentsIn',
  titleKeyNoDropdown: 'myStudents',
};

const StudentsTab = ({ classesList = [] }) => {

  const columns = TAB_CONFIG.columns.map(col => col.type === CellType.TEXT_MONSTER && isCharedi() ? { ...col, cssClass: `${col.cssClass} ${classes.col_textMonsterCharedi}` } : col);
  const { contestId } = useParams();
  const { texts } = useSelector(state => state.translate);
  const { school } = useSelector(state => state.auth);
  const [selectedClass, setSelectedClass] = useState(() => classesList[0] ? { classId: classesList[0].classId, ordinal: classesList[0].ordinal } : null);
  const [scoreboardData, setScoreboardData] = useState([]);

  useEffect(() => {
    if (!selectedClass)
      return;
    if (!contestId)
      return;
    const fetchStudents = async () => {
      try {
        const response = await fetchGetAuth(`${window.config.apiUrl}/${TAB_CONFIG.studentsEndpoint}?contestId=${contestId}&schoolId=${school.id}&classId=${selectedClass?.classId}&ordinal=${selectedClass?.ordinal}`);
        setScoreboardData(response);
      } catch (error) {
        console.error('Error fetching students scoreboard:', error);
      }
    };
    fetchStudents();
  }, [selectedClass, school?.id, contestId]);

  return (
    <div className={classes.studentsTab}>
      {classesList.length > 1 ?
        <div className={classes.tabHeader}>
          <div className={classes.tabTitle}>
            <p className={classes.tabTitleText}>{texts[TAB_CONFIG.titleKey]}</p>
            <ChangeClass classesList={classesList} selectedClass={selectedClass} onClassChange={setSelectedClass} />
          </div>
        </div>
        :
        <div className={classes.tabHeader}>
          <div className={classes.tabTitle}>
            <p className={classes.tabTitleText}>{texts[TAB_CONFIG.titleKeyNoDropdown]}</p>
          </div>
        </div>
      }
      <ScoreboardTable
        rows={scoreboardData || []}
        boardConfig={{ columns }}
        tabType={TAB_CONFIG.tabType}
      />
    </div>
  );
};

export default StudentsTab;
